import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container text-center py-3">
        <p>© {new Date().getFullYear()} BuildNear. All rights reserved.</p>
        <p><small>Made with ❤️ for construction needs</small></p>
      </div>
    </footer>
  );
}
